import getSubdomain from '../../utils/getSubdomain';
import HomePage from './HomePage/HomePage';
import LandingPage from './LandingPage/LandingPage';

export default function PublicIndexPage() {
  return getSubdomain() ? <LandingPage /> : <HomePage />;
}
